import { SystemError } from "@ascend-ltd/accounts-core";

export const initializeEnvironmentValue = <R extends string>(
  value: string | undefined
): R => {
  if (value === undefined) {
    throw new SystemError.Unexpected("environment value is undefined");
  }
  return value as R;
};
